import { fetchPostText } from './CommonServiceUtils';
const SHOUTOUT_CORE_SERVICE = 'https://api.getshoutout.com/coreservice/';

const exportContacts = (requestObj) => {

    return fetchPostText(`${SHOUTOUT_CORE_SERVICE}contacts/filter/export`, requestObj);
}


export { exportContacts }